import Layout from './Layout.js';

export default class Row extends Layout {
  constructor() {
    super('div', 'muigui-row');
  }
}
